// #573: Wer/wann/warum eine Mail erledigt wurde (Spalten erledigt_am/_von/_automatisch, Trigger
// emails_erledigt_protokoll) und der Schalter für die Automatik „Rechnung erfasst → erledigt“.
import { supabase } from '../supabase/client';

export const SCHALTER_ERLEDIGT_BEI_RECHNUNG = 'mail_erledigt_bei_rechnung';

const AUTOMATIK_TEXT: Record<string, string> = {
  rechnung: 'automatisch, weil die Rechnung aus dem Anhang erfasst wurde',
};

const p2 = (n: number) => String(n).padStart(2, '0');

/** „Erledigt am 27.10.2026 um 08:25 · von Sarah Zahn“ – null, wenn nicht erledigt oder vor dem 28.10.2026 erledigt (unbekannt). */
export function erledigtText(
  email: { erledigt?: boolean | null; erledigt_am?: string | null; erledigt_von?: string | null; erledigt_automatisch?: string | null },
  name: string | null,
): string | null {
  if (!email.erledigt || !email.erledigt_am) return null;
  const d = new Date(email.erledigt_am);
  if (Number.isNaN(d.getTime())) return null;
  const wann = `Erledigt am ${p2(d.getDate())}.${p2(d.getMonth() + 1)}.${d.getFullYear()} um ${p2(d.getHours())}:${p2(d.getMinutes())}`;
  if (email.erledigt_automatisch) return `${wann} · ${AUTOMATIK_TEXT[email.erledigt_automatisch] ?? 'automatisch'}`;
  if (email.erledigt_von) return `${wann} · von ${name || 'einem Teammitglied'}`;
  return wann;
}

/** Schalter im Control Center; fehlt der Eintrag, ist die Automatik an (Verhalten seit 22.07.2026). */
export async function ladeSchalterErledigtBeiRechnung(): Promise<boolean> {
  const { data, error } = await supabase.from('app_settings').select('value').eq('key', SCHALTER_ERLEDIGT_BEI_RECHNUNG).maybeSingle();
  if (error) throw error;
  return (data?.value as { aktiv?: boolean } | null)?.aktiv !== false;
}
export async function setzeSchalterErledigtBeiRechnung(aktiv: boolean): Promise<void> {
  const { error } = await supabase.from('app_settings').upsert({ key: SCHALTER_ERLEDIGT_BEI_RECHNUNG, value: { aktiv }, updated_at: new Date().toISOString() }, { onConflict: 'key' });
  if (error) throw error;
}
